export default __webpack_public_path__ + "static/port-6-27186529c46f052794415872cf41ab6d.jpeg";